export default __webpack_public_path__ + "static/media/berlinMinia.46dcfef5.png";